import { Action } from '@ngrx/store';
import { MargTaxRateState } from './state';

export enum SeriesDetailsActionsType {
  SetDefaultMargTaxRate = '[SeriesDeteils] Set Default MargTaxRate',

  SetMargTaxRate = '[SeriesDeteils] Set MargTaxRate'
}

export class SetDefaultMargTaxRate implements Action {
  public readonly type = SeriesDetailsActionsType.SetDefaultMargTaxRate;
  constructor(public payload: string) {}
}

export class SetMargTaxRate implements Action {
  public readonly type = SeriesDetailsActionsType.SetMargTaxRate;

  constructor(public payload: MargTaxRateState) {}
}

export type SeriesDetailsActionsUnion = SetMargTaxRate | SetDefaultMargTaxRate;
